export default class Ordering {
  constructor(public readonly orderBy: string, public readonly orderAsc: boolean) {}
}
